// removed by extract-text-webpack-plugin
module.exports = {"component":"_2vwVaK4fln6qSeKQv3UTvE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionsPanel/ActionsPanel.css
// module id = 1049
// module chunks = 0